import { defineMessages } from '@jutro/locale';

export default defineMessages({
    pendingChanges: {
        id: 'ml.gateway.accountPendingPolicyChanges.Pending Changes',
        defaultMessage: 'Pending Changes'
    },
    expand: {
        id: 'ml.gateway.accountPendingPolicyChanges.Expand',
        defaultMessage: 'Expand'
    },
    collapse: {
        id: 'ml.gateway.accountPendingPolicyChanges.Collapse',
        defaultMessage: 'Collapse'
    },
    withdrawPendingPopupTitle: {
        id: 'ml.gateway.accountPendingPolicyChanges.withdrawPendingPopupTitle',
        defaultMessage: 'Delete change'
    },
    withdrawPendingPopupMsg: {
        id: 'ml.gateway.accountPendingPolicyChanges.withdrawPendingPopupMsg',
        defaultMessage: 'Are you sure you want to delete this change?'
    },
    withdrawPendingFailMsg: {
        id: 'ml.gateway.accountPendingPolicyChanges.withdrawPendingFailMsg',
        defaultMessage: 'Failed to delete this policy change'
    },
    deletingChange: {
        id: 'ml.gateway.accountPendingPolicyChanges.Deleting change',
        defaultMessage: 'Deleting change'
    },
    loadingPendingPolicyChanges: {
        id: 'ml.gateway.accountPendingPolicyChanges.Loading Pending Policy Changes',
        defaultMessage: 'Loading Pending Policy Changes'
    },     
    loadPendingFailMsg: {
        id: 'ml.gateway.accountPendingPolicyChanges.loadPendingFailMsg',
        defaultMessage: 'Failed to load pending policy changes'
    },
    noPendingPolicyChangesFound: {
        id: 'ml.gateway.accountPendingPolicyChanges.No pending policy changes found',
        defaultMessage: 'No pending policy changes found'
    },
    transactionDate: {
        id: 'ml.gateway.accountPendingPolicyChanges.Transaction Date',
        defaultMessage: 'Transaction Date'
    },
    policyNum: {
        id: 'ml.gateway.accountPendingPolicyChanges.Policy #',
        defaultMessage: 'Policy #'
    },
    description: {
        id: 'ml.gateway.accountPendingPolicyChanges.Description',
        defaultMessage: 'Description'
    },
    jobStatus: {
        id: 'ml.gateway.accountPendingPolicyChanges.Job Status',
        defaultMessage: 'Job Status'
    },
    actions: {
        id: 'ml.gateway.accountPendingPolicyChanges.Actions',
        defaultMessage: 'Actions'
    },
    continueChange: {
        id: 'ml.gateway.accountPendingPolicyChanges.Continue Change',
        defaultMessage: 'Continue Change'
    }
});